import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { deleteEventRegistration } from "actions/action";
import { getEventRegistrationInfo } from "actions/action";
import { imageBaseURL } from "actions/Base_URL";

const ViewEventRegistration = ({ data }) => {
  const location = useLocation();
  const navigate = useNavigate()
  const { eventId } = location.state;
  const userId = localStorage.getItem("user_id");
  const [formData, setFormData] = useState({
    id: "",
    data: null
  });

  const fetchFormData = async () => {
    try {
      const response = await getEventRegistrationInfo(eventId, userId)
      if (response.status !== 404) {
        data = response.data.registration;
        setFormData({
          ...formData,
          data: { ...data.form_data, file_uploads: data.file_uploads },
          id: data.event_registration_id
        });
      }

    } catch (err) {
      console.log(err);

    }
  }

  const handleDeleteEventRegistration = async (id) => {
    try {
      const getApiResponse = await deleteEventRegistration(id);
      if (getApiResponse.status == 200) {
        navigate("/student/events");
      }
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  }
  useEffect(() => {
    fetchFormData();
  }, [])
  return (
    <div className="relative">
      <div className="flex justify-between items-center  px-4 mt-6">
        <p className="font-semibold text-lg text-white">Registration Details</p>
        <div>
          <Tooltip title="Go Back" arrow>
            <button
              className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              type="button"
              onClick={() => navigate(-1)}
            >
              {"<"}
            </button>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <button
              whileHover={{ scale: 1.2, color: "#DC2626" }}
              whileTap={{ scale: 0.9 }}
              type="button"
              disabled={formData.id === ""}
              className="text-red-500 hover:text-red-700 focus:outline-none mx-4"
              onClick={() => handleDeleteEventRegistration(formData.id)}
            >
              <FontAwesomeIcon icon={faTrash} className="text-xl" />
            </button>
          </Tooltip>

          {/* <Tooltip title="Edit" arrow>
                <button
                  whileHover={{ scale: 1.2, color: "#FACC15" }}
                  whileTap={{ scale: 0.9 }}
                  type="button"
                  disabled={formData.data===null}
                  onClick={()=> navigate(`/student/student-event-registration`, {state:{type:"edit", id:eventId, formValues:{id:formData.id,data:formData.data}}})}
                  className="text-white focus:outline-none mx-3 hover:text-yellow-500">
                  <FontAwesomeIcon icon={faPenToSquare} className="text-xl" />
                </button>
              </Tooltip> */}
        </div>
      </div>
      <div className="mt-6 px-6 relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blueGray-700">
        <div className="min-h-screen-75 w-full overflow-x-auto pt-6">
          {formData.data ? Object.entries(formData.data).map(([key, value]) => {
            // Skip rendering if the key is 'image_upload', 'ppt_upload' (handled in file_uploads)
            // or if the key exists in file_uploads (to prevent [object Object] for dynamic files)
            if (key !== "file_uploads" && (
              key === "image_upload" ||
              key === "ppt_upload" ||
              (formData.data.file_uploads && formData.data.file_uploads[key])
            )) {
              return null;
            }

            return (
              <div key={key} className="flex flex-col sm:flex-row sm:items-start py-2 min-h-4 w-full border-b border-blueGray-600">
                {key !== "file_uploads" ? (
                  <p className="w-full">
                    <span className="font-bold text-lightBlue-500 w-40 capitalize">{key.replace(/_/g, ' ')}:</span>
                    <span className="text-white ml-2"> {String(value)}</span>
                  </p>
                ) : (

                  <div className="w-full">
                    <span className="font-bold text-lightBlue-500 capitalize">{key.replace(/_/g, ' ')}:</span>
                    <div className="mt-2 space-y-1">
                      {Object.entries(value).map(([fileKey, fileUrl]) => {
                        // Function to get a better display name for file uploads
                        const getDisplayName = (key) => {
                          if (key.includes('ppt_upload')) {
                            return 'PowerPoint Presentation';
                          } else if (key.includes('image_upload')) {
                            return 'Image Files';
                          } else if (key.includes('document')) {
                            return 'Document';
                          } else if (key.includes('file')) {
                            return 'Additional Files';
                          } else {
                            // Convert underscore to space and capitalize
                            return key.replace(/_/g, ' ').replace(/\d+/g, '').trim().replace(/\b\w/g, l => l.toUpperCase());
                          }
                        };

                        return (
                          <div key={fileKey} className="flex items-center space-x-2">
                            <span className="text-sm font-medium text-white">{getDisplayName(fileKey)}:</span>
                            <button
                              onClick={() => window.open(`${imageBaseURL}${fileUrl}`, "_blank")}
                              className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                            >
                              View
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )
          }) : (
            <div className="w-full flex justify-center">
              <div className="bg-red-500 w-8/12 text-white text-center py-2 px-4 rounded-lg font-bold shadow-md">
                Did not register yet
              </div>
            </div>
          )}



        </div>
      </div>
    </div>

  );
};

export default ViewEventRegistration;
